module.exports = __webpack_public_path__ + "static/img/login.929d7b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login.jpg
// module id = Didw
// module chunks = 1